//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vakgroepPosts from '~/graphql/queries/vakgroepPosts.gql';
import vakgroepen from '~/graphql/queries/vakgroepen.gql';

export default {
  auth: false,
  apollo: {
    vakgroepPosts: {
      query: vakgroepPosts,
      throttle: 500,
      debounce: 150,
      variables() {
        return {
          page: this.page,
          per_page: this.perPage,
          query: this.query.length ? this.query : null,
          vakgroep: this.vakgroep.length ? this.vakgroep : null,
          type: this.type.length ? this.type : null,
        };
      },
      result(data) {
        if (this.filtersChanged) {
          this.filtersChanged = false;
          this.posts = [];
        }

        if (data.data.vakgroepPosts && data.data.vakgroepPosts.length) {
          data.data.vakgroepPosts.forEach((post) => {
            if (!this.posts.includes(post)) {
              this.posts.push(post);
            }
          });
          this.moreAvailable = data.data.vakgroepPosts.length >= this.perPage;
        } else {
          this.moreAvailable = false;
        }
        this.pages++;
      },
    },
    vakgroepen: {
      query: vakgroepen,
    },
  },
  data() {
    return {
      placeholderImage: require('~/assets/img/post_placeholder.png'),
      vakgroepPosts: {},
      posts: [],
      page: 1,
      perPage: 10,
      moreAvailable: true,
      vakgroepen: [],
      filtersChanged: false,
      types: [
        {label: 'Alle types', value: ''},
        {label: 'Vakgroepinformatie', value: 'Vakgroepinformatie'},
        {label: 'Scholingsinformatie', value: 'Scholingsinformatie'},
        {label: 'Nieuwsberichten vakgroep', value: 'Nieuwsberichten vakgroep'},
        {label: 'Oproep vakgroep', value: 'Oproep vakgroep'},
      ],
      query: '',
      vakgroep: '',
      type: '',
    };
  },
  computed: {
    vakgroepenComputed() {
      return this.vakgroepen.map((v) => {
        return {value: v.id, label: v.title};
      });
    },
  },
  methods: {
    loadMore() {
      if (this.moreAvailable) {
        this.page++;
      }
    },
    setFiltersChanged() {
      this.page = 1;
      this.filtersChanged = true;
    },
  },
};
